export const CopilotTheme = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
} as const

export const CopilotAuthEndpoints = {
  VERIFY: '/contractor/session/ping',
  ONE_TIME_CODE: '/auth/contractor/one-time-code',
  LOGIN: '/auth/contractor/login',
  LOGOUT: '/auth/contractor/logout',
} as const
